// Shared number formatting for the vegetation change demo. Pins the en-AU
// locale so hectare/percent readouts are consistent across panels.

const LOCALE = "en-AU";

export function formatHa(n: number, decimals = 1): string {
  return n.toLocaleString(LOCALE, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

export function formatPct(n: number, decimals = 1): string {
  return `${n.toLocaleString(LOCALE, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })}%`;
}
